import { PATH_SETVC } from '@/store/mutations-type'
const common = require('@/lib/common')

const state = {
  vesselOptCache: common.getStoreData('pathvesselopt') || [],
}

const mutations = {
  [PATH_SETVC](state, vesselInfo) {
    let vo = common.getStoreData('pathvesselopt') || [];
    if(vo.length > 4){
      vo.pop()
      vo.unshift(vesselInfo)
    }else{
      vo.unshift(vesselInfo)
    }
    state.vesselOptCache = vo;
    common.setStoreData('pathvesselopt', vo)
  },
  
}

const actions = {
  async setVC({ state, commit }, vesselInfo) {
    commit(PATH_SETVC, vesselInfo)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/vesselpath.js